export default __webpack_public_path__ + "static/media/BEL.52f28c94.svg";